import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-lg-100 w-sm-90 w-xs-90 mt-10 mt-lg-15 mx-lg-auto mx-auto mx-sm-auto mx-xs-auto" }
const _hoisted_2 = { class: "card pb-10 mb-5 mb-xxl-8" }
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "mb-13 text-center" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "mb-3 mt-10" }, "Change Your Subscription")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PlanColumnView = _resolveComponent("PlanColumnView")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_PlanColumnView, {
          "show-free": false,
          "plan-code": _ctx.plan.code,
          "is-change": true
        }, null, 8, ["plan-code"])
      ])
    ])
  ]))
}